module.exports = __webpack_public_path__ + "static/media/Gremlin.93f3ec54.png";